import type { LocaleType } from './LocaleType';

const locales: Record<string, LocaleType> = {
  de: {
    id: 'de',
    name: 'German',
    path: 'de',
  },
  en: {
    id: 'en',
    name: 'English',
    path: 'en',
  },
  es: {
    id: 'es',
    name: 'Español ',
    path: 'es',
  },
  fr: {
    id: 'fr',
    name: 'French',
    path: 'fr',
  },
  nl: {
    id: 'nl',
    name: 'Dutch',
    path: 'nl',
  },
  pl: {
    id: 'pl',
    name: 'Polski',
    path: 'pl',
  },
  pt: {
    id: 'pt',
    name: 'Português',
    path: 'pt',
  },
};

export default locales;
